import {
  ApiPostGameQuestionParams,
  apiPostGameQuestionPath,
  ApiPostGameQuestionResponse,
  ApiPostGameQuestionMetaDataFaderGrader,
} from "apiRoutes/apiQuestionRoutes";
import { getGamePoints } from "shared/games/getPoints";
import { getGameDescription } from "shared/games/helpers";
import { GameAnswerFaderGrader } from "shared/games/types/GameAnswers";
import { GameQuestionFaderGrader } from "shared/games/types/GameQuestions";
import api from "util/api";
import createGame from "../../createGame";
import FaderGraderFailedScreen from "./pages/FaderGraderFailedScreen";
import FaderGraderGame from "./pages/FaderGraderGame";
import generateOnSubmitHandler from "shared/games/generateOnSubmitHandler";

export default createGame<GameQuestionFaderGrader, GameAnswerFaderGrader>({
  Game: FaderGraderGame,
  FailureScreen: FaderGraderFailedScreen,
  onSubmit: generateOnSubmitHandler<
    GameQuestionFaderGrader,
    GameAnswerFaderGrader,
    ApiPostGameQuestionMetaDataFaderGrader
  >(({ answer, game, pointsEarned, question }) => ({
    correct: answer.correct,
    difficulty: question.difficulty,
    points: pointsEarned,
    game: question.type,
    instrument: question.instrument.instrument,
    technique: game.technique,
    metadata: {
      answer_volume: answer.submission,
      question_volume: question.volume,
    },
  })),
});
